import { Card, CardContent } from "../../../components/ui/card_v2"
import { Progress } from "../../../components/ui/progress"
import { Coins, ArrowUpRight, ArrowDownRight, Wallet } from "lucide-react"
import localization from "services/localization"
import { useThemeStore } from "../../../context/useThemeStore"

export function CreditStats({ total, allocated, used, remaining }) {
  const { theme } = useThemeStore();
  const allocatedPct = Math.round((allocated / total) * 100)
  const usedPct = Math.round((used / total) * 100)

  const stats = [
    {
      label: localization.total_credits || "Total Credits",
      value: total,
      icon: Coins,
      iconColor: "text-amber-500",
      iconBg: "bg-amber-50",
      description: localization.allocated_to_org || "Allocated to organization",
    },
    {
      label: localization.distributed || "Distributed",
      value: allocated,
      icon: ArrowUpRight,
      iconColor: "text-blue-500",
      iconBg: "bg-blue-50",
      description: `${allocatedPct}% ${localization.of_total || "of total"}`,
      progress: allocatedPct,
      progressColor: "bg-blue-500",
    },
    {
      label: localization.used_by_members || "Used by Members",
      value: used,
      icon: ArrowDownRight,
      iconColor: "text-emerald-500",
      iconBg: "bg-emerald-50",
      description: `${usedPct}% ${localization.of_total || "of total"}`,
      progress: usedPct,
      progressColor: "bg-emerald-500",
    },
    {
      label: localization.unallocated || "Unallocated",
      value: remaining,
      icon: Wallet,
      iconColor: "text-orange-500",
      iconBg: "bg-orange-50",
      description: localization.available_to_distribute || "Available to distribute",
    },
  ]

  const getProgressColor = (percent) => {
    if (percent >= 90) return "bg-red-500"
    if (percent >= 70) return "bg-amber-500"
    return "bg-emerald-500"
  }

  const select_bg = theme === "dark" ? "bg-[var(--card-bg)] text-white" : "bg-white text-foreground"

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {stats.map((stat) => (
        <Card key={stat.label} className={"border shadow-sm pt-4 " + select_bg}>
          <CardContent className={"p-4 " + select_bg}>
            <div className="flex items-start justify-between">
              <div className="space-y-1">
                <p className="text-sm font-medium text-muted-foreground">
                  {stat.label}
                </p>
                <p className="text-2xl font-bold tracking-tight">
                  {stat.value.toLocaleString()}
                </p>
              </div>
              <div className={`rounded-lg p-2.5 ${stat.iconBg}`}>
                <stat.icon className={`h-5 w-5 ${stat.iconColor}`} />
              </div>
            </div>
            {stat.progress !== undefined ? (
              <div className="mt-3 space-y-1.5">
                <Progress value={stat.progress} className="h-1.5" colorClass={getProgressColor(stat.progress)} />
                <p className="text-xs text-muted-foreground">{stat.description}</p>
              </div>
            ) : (
              <p className="mt-3 text-xs text-muted-foreground">
                {stat.description}
              </p>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  )
}
